angular
  .module('index', [
	'theme',
	'forms',
	'forms.fields.formbuilder',  // requires "formBuilder": "^2.9.8"
    'ui.router',
    'persistent',
	'languages',
	'ngSanitize',
	'uiGmapgoogle-maps',
	'dialogs.main'
	])
	
  .config(function ($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, $locationProvider) {
		$urlRouterProvider.otherwise('/');
	
		$urlMatcherFactoryProvider.type("previous", {
			encode: function(value){ return 'previous/' + value },
			decode: function(value){ return 0|value.replace(/^previous\//, '') },
			pattern: /previous\/[0-9]+/
		})

		$urlMatcherFactoryProvider.type("invitation", {
			encode: function(value){ return 'invitation/' + value },
			decode: function(value){ return value.replace(/^invitation\//, '') },
			pattern: /invitation\/[^/]+/
		})

		$stateProvider
			.state("index", {
				url: "/",
				templateUrl: 'partials/index/event-list.html',
				controller: 'EventListController',
				controllerAs: '$ctrl',
			})
			.state("event", {
				url: "/:name/{eventID:previous}/{eventToken:invitation}",
				params: {
					eventID: { squash: true, value: null },
					eventToken: { squash: true, value: null },
				},
				views: {
					"": {
						controller: 'EventController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event.html',
					},
					/*
					"aside@": {
						controller: 'HeaderController',
						controllerAs: '$header',
						templateUrl: 'partials/index/event-aside.html',
					}
					*/
				}
			})
			.state("event-confirm", {
				url: "/confirm/:hash",
				views: {
					"": {
						controller: 'EventConfirmController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-confirm.html',
					}
				}
			})
			.state("event-bulk-confirm", {
				url: "/bulk-confirm/:hash",
				views: {
					"": {
						controller: 'EventBulkConfirmController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-bulk-confirm.html',
					}
				}
			})
			.state("proxy-event-confirm", {
				url: "/proxy-confirm/:hash",
				views: {
					"": {
						controller: 'EventProxyConfirmController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-confirm.html',
					}
				}
			})
			.state("regstration-info", {
				url: "/status/:hash",
				views: {
					"": {
						controller: 'EventRegistrationController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-registration.html',
					}
				}
			})
			.state("proxy-regstration-info", {
				url: "/proxy-status/:hash",
				views: {
					"": {
						controller: 'EventProxyRegistrationController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-registration.html',
					}
				}
			})
			.state("regstration-cancel", {
				url: "/cancel/:hash",
				views: {
					"": {
						controller: 'EventCancelController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-cancel.html',
					}
				}
			})
			.state("regstration-change-group", {
				url: "/change-group/:hash",
				views: {
					"": {
						controller: 'EventChangeGroupController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event-change-group.html',
					}
				}
			})
			/*
			.state("event-previous", {
				url: "/:name/previous/:id",
				views: {
					"": {
						controller: 'EventPreviousController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event.html',
					},
					"aside@": {
						controller: 'HeaderController',
						controllerAs: '$header',
						templateUrl: 'partials/index/event-aside.html',
					}
				}
			})*/
			.state("event.thankyou", {
				url: "/thankyou",
				templateUrl: 'partials/index/event-thankyou.html',
			})
			/*.state("event-invitation", {
				url: "/:name/invitation/:token",
				views: {
					"": {
						controller: 'EventController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event.html',
					},
					"aside@": {
						controller: 'HeaderController',
						controllerAs: '$header',
						templateUrl: 'partials/index/event-aside.html',
					}
				}
			})*/
			/*
			.state("event-previous-invitation", {
				url: "/:name/previous/:id/invitation/:token",
				views: {
					"": {
						controller: 'EventPreviousController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/event.html',
					},
					"aside@": {
						controller: 'HeaderController',
						controllerAs: '$header',
						templateUrl: 'partials/index/event-aside.html',
					}
				}
			})
			*/
			/*.state("event-invitation.thankyou", {
				url: "/thankyou",
				templateUrl: 'partials/index/event-thankyou.html',
			})*/
			.state("survey", {
				url: "/survey/:name",
				views: {
					"": {
						controller: 'SurveyController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/survey.html',
					},
				}
			})
			.state("event-survey", {
				url: "/eventsurvey/{participat_short_code:[A-Za-z0-9_-]+}",
				views: {
					"": {
						controller: 'EventSurveyController',
						controllerAs: '$sCtrl',
						templateUrl: 'partials/index/survey.html',
					},
				},
				resolve: {
					SurveyInfo: function(Classes, $stateParams) {
						return Classes.EventParticipation.get_survey_info({hash: $stateParams.participat_short_code}).then(function(result){
							return result;
						}, function(error){
							return {error:error};  // pozwól na obsługe błedu po stronie kontrollera
						})
					},
					ParticipantShortCode: function($stateParams) {
						return $stateParams.participat_short_code;
					}
				},
			});
			//$locationProvider.html5Mode({enabled: true, requireBase: false});
  })
   .run(function($rootScope, $location){
		$rootScope.systemName = 'Wydarzenia Industry';
		window.$rootScope = $rootScope;

        $rootScope.$on('$stateChangeSuccess', function (event) {
			// gtag('config', 'AW-1055466125', {'page_path': $location.path()});
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'pageview',
				'pagePath': $location.path()
			});
			
			fbq('init', '495944647652309');
			fbq('track', 'PageView');
        });
  })
  .config(function($themeInitialSettingsProvider){
		$themeInitialSettingsProvider.set('fullscreen', true);
  })
  .config(function($logProvider){
    $logProvider.debugEnabled(true);
  })
 .filter('text_teaser', function () {
        return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                  //Also remove . and , so its gives a cleaner result.
                  if (value.charAt(lastspace-1) === '.' || value.charAt(lastspace-1) === ',') {
                    lastspace = lastspace - 1;
                  }
                  value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
	})
	.service('MetaService', function(){
		var self = this;
		this.meta = {
			title: 'Wydarzenia Industry',
			contact: null,
			venues: null,
			eventPreviousList: null,
			eventCurrent: null,
			metaDescription: null,
			metaKeywords: null
		}
		this.setTitle = function(title) {
			self.meta.title = title || 'Wydarzenia Industry';
		}
		this.setContact = function(contact) {
			self.meta.contact = contact || null;
		}
		this.setVenues = function(venues) {
			self.meta.venues = venues || null;
		}
		this.setEventPreviousList = function(list) {
			self.meta.eventPreviousList = list || [];
		}
		this.setEventCurrent = function(event) {
			self.meta.eventCurrent = event || null;
		}
		this.setMetaDescription = function(desc) {
			self.meta.metaDescription = desc || null;
		}
		this.setMetaKeywords = function(keywords) {
			self.meta.metaKeywords = keywords || null;
		}
		this.get = function(item) {
			return self.meta[item];
		}
	})
	.service('EventService', function(){
		var self = this;
		this.variables = {
			event_default_group: {},
		}
		this.setEventDefaultGroup = function(eventDefaultGroups) {
			self.variables.event_default_group = eventDefaultGroups || {};
		}
		this.get = function(item) {
			return self.variables[item];
		}
	})
	.controller('HeadController', function($scope, MetaService) {
		this.getTitleWithSuffix = function() {
			var title = MetaService.get('title');
			var suffix = 'Wydarzenia Industry';
			if (title.indexOf(suffix) == -1) title += ' - ' + suffix;
			return title;
		}
		this.getMetaDescription = function(){
			return MetaService.get('metaDescription');
		}
		this.getMetaKeywords = function(){
			return MetaService.get('metaKeywords');
		}
	})
	.controller('HeaderController', function($scope, MetaService, $stateParams, LocaleService) {

        var self = this;
		self.eventToken = $stateParams.token || null;
		this.getTitle = function(){
			return MetaService.get('title');
		}
		this.getTitleWithSuffix = function() {
			var title = MetaService.get('title');
			var suffix = 'Wydarzenia Industry';
			if (title.indexOf(suffix) == -1) title += ' - ' + suffix;
			return title;
		}

		this.getContact = function() {
			return MetaService.get('contact');
		}

		this.getVenues = function() {
			return MetaService.get('venues');
		}
		
		this.getEventPreviousList = function() {
			return MetaService.get('eventPreviousList');
		}

		this.getEventCurrent = function() {
			return MetaService.get('eventCurrent');
		}
	})	
	.run( ['$rootScope', '$state', '$stateParams',
                      function ($rootScope,   $state,   $stateParams) {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams; 
	}])
  ;

// Angular-Translate configuration
angular.module('languages')
	// Angular-Translate configuration
	.constant('LOCALES', {
		'locales': {
			//'en_US': 'English',
			'pl_PL': 'Рolski'
		},
		'preferredLocale': 'pl_PL',
		'dir': 'assets/locales'
	})

 
